import ProjectsDetails from "../../components/ProjectsDetails/Index";

const Projects = () => {
  return <ProjectsDetails />;
};

export default Projects;
